module.exports = __webpack_public_path__ + "static/media/after-effects.37768ba2.png";